import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import NavChevron from '../../../images/nav-chevron.svg';
import Link from '../Link';

export const Dropdowns = styled.div`
  flex: 1 0 auto;
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    display: inline-flex;
    align-items: center;
  }
`;

export const Dropdown = styled.div`
  position: relative;
  border-radius: 6px 6px 0px 0px;
  padding: 10px;

  &:lang(fr) {
    padding: 10px 8px;
  }

  &::after {
    content: '';
    height: 6px;
    width: 6px;
    display: block;
    position: absolute;
    left: 100%;
    bottom: 0;
  }
`;

export const DropdownBtn = styled.button`
  font-size: 1rem;
  line-height: 150%;
  border-bottom: ${({ $isActive }) =>
    $isActive ? `1px solid #B82118` : `1px solid transparent`};

  &::after {
    content: ${`url(${NavChevron})`};
    position: relative;
    margin: 0 0 0 10px;
  }
`;

export const DropdownMenu = styled.div`
  z-index: 10;
  position: absolute;
  top: calc(100% - 1px);
  width: 15.625rem;
  display: ${({ $isActive }) => ($isActive ? 'flex' : 'none')};
  flex-direction: column;
  background-color: ${themeGet('colors.white')};
  border-radius: 0.5rem;
  padding: 1.5rem 1.25rem;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
`;

export const NavLink = styled(Link)`
  &:hover,
  &:focus {
    text-decoration: underline;
    text-underline-offset: 0.35rem;
    text-decoration-color: ${themeGet('colors.esso-red')};
  }
`;

export const DropdownLink = styled(Link)`
  justify-content: start;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0rem;
  }

  &:hover,
  &:focus {
    font-color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.35rem;
    text-decoration-color: ${themeGet('colors.main-text')};
  }
`;
